import classes from './BackgroundPopup.module.css'

function BackgroundPopup({ onCancel }) {
  return (
    <div
      className={classes.Background}
      onClick={() => {
        onCancel(null)
      }}
    ></div>
  )
}

export default BackgroundPopup
